import apiClient from '@/core/api/';

//constants
const reportBaseApiURL = 'api/report';

export const getInvestigationRequestReport = async (
  requestNumber,
  isEn = false
) =>
  await apiClient.get(
    `${reportBaseApiURL}/investigationrequest/${requestNumber}`,
    {
      params: {
        isEn,
      },
    }
  );

export const getAuthorizationLetterReport = async (
  requestNumber,
  isEn = false
) =>
  await apiClient.get(
    `${reportBaseApiURL}/authorizationLetter/${requestNumber}`,
    {
      params: {
        isEn,
      },
    }
  );

export const getStatisticsReport = async () =>
  await apiClient.get(`${reportBaseApiURL}/stadisticReport`);

export const getAuthorizedRequestsReport = async (dateFrom, dateTo) =>
  await apiClient.get(`${reportBaseApiURL}/authorizedRequests`, {
    params: {
      dateFrom,
      dateTo,
    },
  });

export const exportAuthorizedRequestsToExcel = async (dateFrom, dateTo) =>
  await apiClient.get(`${reportBaseApiURL}/authorizedRequests/export`, {
    params: {
      dateFrom,
      dateTo,
    },
    responseType: 'blob',
  });

export const getDashboardReport = async (dateFrom, dateTo, filters = {}) =>
  await apiClient.get(`${reportBaseApiURL}/dashboard`, {
    params: {
      dateFrom,
      dateTo,
      ...filters,
    },
  });

export const getEficienciaTecnicaReport = async (
  dateFrom,
  dateTo,
  filters = {}
) =>
  await apiClient.get(`${reportBaseApiURL}/eficienciaTecnica`, {
    params: {
      dateFrom,
      dateTo,
      ...filters,
    },
  });

export const getHistorialReport = async (claimId) =>
  await apiClient.get(`${reportBaseApiURL}/historial/${claimId}`);

export const getServiciosExcelReport = async (
  dateFrom = undefined,
  dateTo = undefined
) =>
  await apiClient.get(`${reportBaseApiURL}/serviciosExcel`, {
    params: {
      dateFrom,
      dateTo,
    },
  });
